import { render, staticRenderFns } from "./hero-generic.vue?vue&type=template&id=33181d00"
import script from "./hero-generic.vue?vue&type=script&lang=js"
export * from "./hero-generic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports